import { ReactNode } from "react";
import { type StateCreator } from "zustand";

export type TBreadCrumbSingle = {
  icon?: ReactNode;
  name: string;
  path: string;
  search?: Record<string, string | undefined>;
};
export type TBreadCrumbStoreState = {
  breadCrumbObjRoutes: TBreadCrumbSingle[];
};
export type TBreadCrumbStoreActions = {
  setBreadCrumbStore: (value: TBreadCrumbSingle[]) => void;
};
const initialBreadCrumbStoreState: TBreadCrumbStoreState = {
  breadCrumbObjRoutes: [],
};

export type TBreadCrumbStore = TBreadCrumbStoreState & TBreadCrumbStoreActions;

export const createBreadcrumbSlice: StateCreator<TBreadCrumbStore> = (set) => ({
  ...initialBreadCrumbStoreState,
  setBreadCrumbStore: (value) => set({ breadCrumbObjRoutes: value }),
});
